import ApiService from "@/common/api.service"

export const AccreditorReportService = {
    getAccreditorReports() {
        return ApiService.get("/accreditorReport")
    },
    getAccreditorReportstWP(query) {
        let queryParam = `/accreditorReport${query}`;
        return ApiService.get(queryParam);
    },

}